/**
 * Format a Date object to YYYY-MM-DD using local timezone components
 * This prevents timezone shifts when converting dates from PostgreSQL
 * @param {Date} date - Date object to format
 * @returns {string|null} - Date string in YYYY-MM-DD format or null
 */
// export function formatDateLocal(date) {
//   if (!(date instanceof Date) || isNaN(date.getTime())) {
//     return null;
//   }
//   const year = date.getFullYear();
//   const month = String(date.getMonth() + 1).padStart(2, '0');
//   const day = String(date.getDate()).padStart(2, '0');
//   return `${year}-${month}-${day}`;
// }

export function formatDateLocal(input) {
  if (!input) return null;

  const date = input instanceof Date ? input : new Date(input);

  if (isNaN(date.getTime())) return null;

  return [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0'),
  ].join('-');
}

/**
 * Format a calendar date as YYYY-MM-DD consistently for all users.
 * Uses the leading date from ISO strings when present, otherwise UTC
 * calendar components so plain dates and API date-only values do not
 * shift by the viewer's local timezone.
 * @param {Date|string|number} input
 * @returns {string|null}
 */
export function formatDateYmdStable(input) {
  if (input === null || input === undefined || input === "") return null;

  if (typeof input === "string") {
    const trimmed = input.trim();
    const ymd = trimmed.match(/^(\d{4}-\d{2}-\d{2})/);
    if (ymd) return ymd[1];
  }

  const date = input instanceof Date ? input : new Date(input);
  if (isNaN(date.getTime())) return null;

  return [
    date.getUTCFullYear(),
    String(date.getUTCMonth() + 1).padStart(2, "0"),
    String(date.getUTCDate()).padStart(2, "0"),
  ].join("-");
}

